import { useEffect, useMemo, useState, type FC } from 'react';
import styles from './index.module.scss';
import PumpSearch from '../pump-search';
import { usePumpPools } from '@hooks/use-pump-pool';

import DataList from './list';
import Pagination from '@components/pagination';
import { type SortParams } from '@models/pump-pool.model';
import { useDebounce } from 'react-use';
import Loading from '@ui/loading';
import type { OpenapiClientPump } from 'src/openapi/pump';
import dayjs from 'dayjs';
import GraduateList from './graduate';

const PumpList: FC<{
  onChangeKingData(data: OpenapiClientPump.GetPoolsResponse['king'] | undefined): void;
  onChangeIsKing(data: boolean): void;
}> = ({ onChangeKingData, onChangeIsKing }) => {
  const [reload, setReload] = useState(1);
  const [page, setPage] = useState(1);
  const [searchName, setSearchName] = useState('');
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState<SortParams>('latest_trade_at');
  const [completed, setCompleted] = useState<boolean | undefined>(false);
  const [isGraduate, setIsGraduate] = useState(false);
  const [direction, setDirection] = useState<'desc' | 'asc'>('desc');

  useDebounce(
    () => {
      setSearch(searchName);
      setPage(1);
    },
    300,
    [searchName],
  );

  const limit = 48;
  const { pools, loading } = usePumpPools({
    search,
    sort,
    completed,
    page,
    reload,
    direction,
    pageSize: limit,
    loopTime: 2000,
  });

  const { finalPools, isKing, kingData } = useMemo(() => {
    let isKing = true;
    if (pools.king) {
      if (
        (pools.king.is_completed &&
          pools.king.completed_at &&
          pools.featured &&
          dayjs(pools.featured.latest_trade_at).valueOf() >
            dayjs(pools.king.completed_at).valueOf()) ||
        (pools.king.king_at && dayjs(pools.king.king_at).add(48, 'hour').valueOf() < Date.now())
      ) {
        isKing = false;
      } else {
        isKing = true;
      }
    }

    const _data = isKing ? pools.king : pools.featured;

    return {
      finalPools: {
        ...pools,
        data: pools.data.filter((item) => item.token_address !== _data?.token_address),
      },
      isKing,
      kingData: _data,
    };
  }, [JSON.stringify(pools)]);

  useEffect(() => {
    onChangeIsKing(isKing);
  }, [isKing]);

  useEffect(() => {
    onChangeKingData(kingData);
  }, [JSON.stringify(kingData)]);

  return (
    <div className={styles.wrapper}>
      <PumpSearch
        onSearch={setSearchName}
        sort={sort}
        onChangePage={setPage}
        onSortChange={setSort}
        completed={completed}
        onCompletedChange={setCompleted}
        onChangeReload={setReload}
        direction={direction}
        onChangeDirection={setDirection}
        onChangeIsGraduate={setIsGraduate}
        isGraduate={isGraduate}
      />
      {isGraduate ? (
        <GraduateList />
      ) : (
        <>
          {loading ? (
            <div className={styles.loading}>
              <Loading size={48} />
            </div>
          ) : (
            <>
              <div className={styles.items}>
                {finalPools.data.map((pool, index) => {
                  // if (
                  //   pool.token_address ===
                  //   '0xdccfc5587c91fac49cd2124c96449c4f0d68998a1d22b8ecf031ebe8697efa4b::acat::ACAT'
                  // ) {
                  //   return null;
                  // }
                  return (
                    <DataList
                      pool={pool}
                      key={pool.pool_id}
                      index={index}
                      isAnimate={isKing && !completed ? true : false}
                    />
                  );
                })}
              </div>

              {finalPools.data.length > 0 && finalPools.total > limit && (
                <Pagination onChange={setPage} page={page} limit={limit} total={finalPools.total} />
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default PumpList;
